import React from "react";
import ReactDOM from "react-dom/client";
import App from './app';

const el = document.getElementById('dealers-map-root')
const locale = el.getAttribute('data-locale');
const root = ReactDOM.createRoot(el);

if (root) {
    root.render(
        <App locale={locale} />
    );
}